module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/thumb/brc-a18dbd992a52c1c176b77d25fb7e3772.jpg";